import { roles } from 'features/hoc';

export const adminUsersRoleRules = {
  menu: { min: roles.contentManager.value },
  users: { min: roles.contentManager.value },
  createUser: { min: roles.contentManager.value },
};
